/** Mirrors crm ContractStatus. */
export const CONTRACT_STATUSES = [
  { value: 'draft', label: 'Draft' },
  { value: 'sent', label: 'Sent for signature' },
  { value: 'signed', label: 'Signed' },
  { value: 'cancelled', label: 'Cancelled' },
] as const;

export type ContractStatus = (typeof CONTRACT_STATUSES)[number]['value'];

export const statusLabel = (s: string): string =>
  CONTRACT_STATUSES.find((x) => x.value === s)?.label ?? s;

export function statusVariant(s: string): 'default' | 'secondary' | 'destructive' | 'outline' {
  if (s === 'signed') return 'default';
  if (s === 'cancelled') return 'destructive';
  if (s === 'sent') return 'secondary';
  return 'outline'; // draft
}
